import React from 'react';
import { v1 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import { StyledFilterWrapper } from './Styles';
import Group, { propTypes as groupPropTypes } from './Group';
import Item from './Item';

const propTypes = {
  testId: PropTypes.string,
  width: PropTypes.number,
  lists: PropTypes.arrayOf(PropTypes.shape(groupPropTypes))
};

const defaultProps = {
  testId: 'selectable-list',
  width: undefined,
  lists: []
};

const SelectableList = ({ testId, width, lists }) =>
  lists.length && (
    <StyledFilterWrapper data-testid={`${testId}-wrapper`} width={width}>
      {lists.map(({ id, items, testId: groupTestId, headline, onClick }) => (
        <Group
          key={id || uuid()}
          id={id}
          items={items}
          testId={groupTestId || testId}
          headline={headline}
          onClick={onClick}
        />
      ))}
    </StyledFilterWrapper>
  );

SelectableList.propTypes = propTypes;
SelectableList.defaultProps = defaultProps;

SelectableList.Group = Group;
SelectableList.Item = Item;

export default SelectableList;
